/* Stylesheet */

.formula {
  margin: 21px 0px 0px 0px;
}
